module.exports = __webpack_public_path__ + "static/media/notification-banner-img@2x.7e2b2b03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notification-banner-img@2x.png
// module id = 592
// module chunks = 1